export const PORTAL_FRONTEND_VERSION = '2.42.8';
export const ADMIN_FRONTEND_VERSION = '1.3.1';
